import { MutationTree } from "vuex";
import { AlertState, AlertModel } from "./types";

export const ADD_ALERT = "ADD_ALERT";
export const REMOVE_ALERT_AT = "REMOVE_ALERT_AT";

export default {
    [ADD_ALERT](state, alert: AlertModel) {
        state.list.push(alert);
    },
    [REMOVE_ALERT_AT](state, idx: number) {
        state.list.splice(idx, 1);
    },
} as MutationTree<AlertState>;
